export default "__VITE_ASSET__CSh4gU4b__"